import { gql } from '@apollo/client'

export const COUNTRIES_OF_LEGAL_ENTITIES = gql`
  query CountriesOfLegalEntities {
    countriesOfLegalEntities
  }
`

export const LEGAL_ENTITY_SEARCH = gql`
  query LegalEntitySearch($search: String!, $limit: Int!) {
    legalEntitySearch(search: $search, limit: $limit) {
      id
      name
    }
  }
`
